var map = {
	"./Anyswap.png": 644,
	"./Anyswap.svg": 645,
	"./Artwork.svg": 646,
	"./Artwork_gmx.svg": 647,
	"./Banxa.png": 648,
	"./DROP_DOWN.svg": 387,
	"./Hop.png": 649,
	"./Hop.svg": 650,
	"./Hop_dark.png": 651,
	"./Hop_dark.svg": 652,
	"./Synapse.png": 653,
	"./Synapse.svg": 654,
	"./bg_buy_oap.svg": 388,
	"./binance.png": 655,
	"./bscscan.png": 656,
	"./btn_big_arbitrum.png": 657,
	"./btn_big_avalanche.png": 658,
	"./btn_big_bsc.png": 659,
	"./btn_big_purchasegmx.png": 660,
	"./btn_big_purchasegmx.svg": 661,
	"./buy_gmx.svg": 389,
	"./buy_gmx_bond.svg": 662,
	"./buy_transfer_eth.svg": 663,
	"./coinbaseWallet.png": 390,
	"./coingecko.png": 664,
	"./cross.svg": 665,
	"./flag_en.svg": 666,
	"./flag_es.svg": 667,
	"./flag_fr.svg": 668,
	"./flag_ja.svg": 669,
	"./flag_ko.svg": 670,
	"./flag_ru.svg": 671,
	"./flag_zh.svg": 672,
	"./glp_icon.svg": 673,
	"./gmx-logo-final-white-small.png": 674,
	"./gmx-logo-final-white.png": 675,
	"./gmx-logo-final.png": 676,
	"./gmx-logo-glow.png": 677,
	"./gmx-logo-with-name.svg": 391,
	"./gmx_logo.svg": 678,
	"./graphite-01.png": 679,
	"./harmony.jpeg": 392,
	"./ic-communityproject.svg": 680,
	"./ic_arbitrum_16.svg": 226,
	"./ic_arbitrum_24.svg": 317,
	"./ic_arbitrum_96.svg": 227,
	"./ic_arbitrum_hover_16.svg": 681,
	"./ic_arrowleft16.svg": 682,
	"./ic_arrowright16.svg": 683,
	"./ic_avalanche_16.svg": 165,
	"./ic_avalanche_24.svg": 318,
	"./ic_avalanche_96.svg": 228,
	"./ic_avax_24.svg": 684,
	"./ic_avax_30.svg": 393,
	"./ic_avax_40.svg": 685,
	"./ic_banxa.svg": 319,
	"./ic_binance_logo.svg": 164,
	"./ic_bnb_24.svg": 686,
	"./ic_bnb_40.svg": 687,
	"./ic_bsc.svg": 688,
	"./ic_bsc_96.svg": 689,
	"./ic_bsc_circle.svg": 189,
	"./ic_btc.b_24.svg": 690,
	"./ic_btc.b_40.svg": 691,
	"./ic_btc_24.svg": 692,
	"./ic_btc_40.svg": 693,
	"./ic_busd_24.svg": 694,
	"./ic_busd_40.svg": 695,
	"./ic_buy_glp.svg": 463,
	"./ic_cash.png": 696,
	"./ic_cash.svg": 697,
	"./ic_checked.svg": 394,
	"./ic_coin.svg": 262,
	"./ic_coingecko_16.svg": 395,
	"./ic_coingecko_hover_16.svg": 698,
	"./ic_convert_down.svg": 699,
	"./ic_copy_16.svg": 464,
	"./ic_cost.svg": 396,
	"./ic_dai_24.svg": 700,
	"./ic_dai_40.svg": 701,
	"./ic_discord.svg": 397,
	"./ic_eth_24.svg": 702,
	"./ic_eth_40.svg": 703,
	"./ic_frax_24.svg": 704,
	"./ic_frax_40.svg": 705,
	"./ic_github.svg": 398,
	"./ic_glp_24.svg": 706,
	"./ic_glp_40.svg": 465,
	"./ic_glp_custom.svg": 707,
	"./ic_gmx.svg": 708,
	"./ic_gmx_24.svg": 320,
	"./ic_gmx_30.svg": 709,
	"./ic_gmx_40.svg": 710,
	"./ic_gmx_64.svg": 711,
	"./ic_gmx_arbitrum.svg": 399,
	"./ic_gmx_avax.svg": 400,
	"./ic_gmx_big.svg": 712,
	"./ic_gmx_custom.svg": 466,
	"./ic_gmx_footer.svg": 713,
	"./ic_harmony_one.svg": 401,
	"./ic_hop.svg": 402,
	"./ic_info.svg": 714,
	"./ic_language24.svg": 403,
	"./ic_link_24.svg": 715,
	"./ic_link_40.svg": 716,
	"./ic_liquidity.svg": 404,
	"./ic_medium.svg": 405,
	"./ic_menu_dots.svg": 717,
	"./ic_metamask_16.svg": 406,
	"./ic_metamask_hover_16.svg": 718,
	"./ic_mim_24.svg": 719,
	"./ic_mim_40.svg": 720,
	"./ic_multiswap.svg": 321,
	"./ic_new_link_16.svg": 467,
	"./ic_olympus.svg": 721,
	"./ic_olympus_arbitrum.svg": 407,
	"./ic_pig.svg": 408,
	"./ic_selector_dropdowns.svg": 722,
	"./ic_settings_16.svg": 723,
	"./ic_settings_24.svg": 724,
	"./ic_sign in_16.svg": 725,
	"./ic_sign_out_16.svg": 468,
	"./ic_simpleswaps.svg": 409,
	"./ic_stats.svg": 410,
	"./ic_stats_big.svg": 726,
	"./ic_synapse.svg": 322,
	"./ic_telegram.svg": 411,
	"./ic_tether_24.svg": 727,
	"./ic_tokens.svg": 728,
	"./ic_totaluser.svg": 412,
	"./ic_trading.svg": 413,
	"./ic_transfer_avax.svg": 729,
	"./ic_twitter.svg": 414,
	"./ic_uni_24.svg": 730,
	"./ic_uni_40.svg": 731,
	"./ic_usdc.e_24.svg": 732,
	"./ic_usdc.e_40.svg": 733,
	"./ic_usdc_24.svg": 734,
	"./ic_usdc_40.svg": 735,
	"./ic_usdt_24.svg": 736,
	"./ic_usdt_40.svg": 737,
	"./ic_wallet_24.svg": 738,
	"./ic_wavax_24.svg": 739,
	"./ic_wavax_40.svg": 740,
	"./ic_wbnb_40.svg": 741,
	"./ic_wbtc_24.svg": 742,
	"./ic_wbtc_40.svg": 743,
	"./ic_weth_24.svg": 744,
	"./ic_weth_40.svg": 745,
	"./lg_arbitrum.svg": 746,
	"./logo-web.png": 469,
	"./logo_GMX.svg": 202,
	"./logo_GMX_small.svg": 747,
	"./logo_oap.svg": 470,
	"./logo_oap_white.svg": 203,
	"./logo_open_white.svg": 415,
	"./long.svg": 416,
	"./metamask-text.svg": 748,
	"./metamask.png": 417,
	"./page-not-found.svg": 749,
	"./position-share-bg.png": 418,
	"./short.svg": 419,
	"./swap.svg": 420,
	"./trading.jpg": 750,
	"./wallet-connect-text.svg": 751,
	"./walletconnect-circle-blue.svg": 421,
	"./wave-01.png": 752,
	"./wave-02.png": 753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643;